export default __webpack_public_path__ + "static/media/NG.d817d5e8.svg";